<template>
  <div class="level row">
    <span :class="['row__label', edit.name !== name ? '' : 'row-label--edit']"
      v-if="!hideLabel">{{displayName}}:</span>
    <template v-if="edit.name !== name">
      <span class="row__value" v-if="name === 'name'">
        {{value}}
        <a href=""
          @click.prevent="edit = {name: 'name', 'value': value}">
            <b-icon icon="pencil"/>
        </a>
      </span>
      <span class="row__value" v-else-if="name === 'type'">
        {{value}}
      </span>
      <span class="row__value" v-else-if="name === 'status'">
        <kyc-details-field-tag
          :edit-allowed="editAllowed"
          :name="name"
          :value="value"
          :display-value="$store.getters.getFormStatusName(value)"
          @edit-clicked="onEditClicked"
        />
      </span>
      <span class="row__value" v-else-if="name === 'fileManagerId'">
        <kyc-details-field-tag
          :edit-allowed="editAllowed"
          :name="name"
          :value="value"
          :displayValue="$store.getters.getStaffNameById(value)"
          @edit-clicked="onEditClicked"
        />
      </span>
      <span class="row__value" v-else>
        <kyc-details-field-tag
          :edit-allowed="editAllowed"
          :name="name"
          :value="value"
          :displayValue="value"
          @edit-clicked="onEditClicked"
        />
      </span>
    </template>
    <template v-else>
        <template v-if="selectOptions">
            <b-field>
              <b-select v-model.trim="edit.value">
                <option
                  :value="option.id"
                  v-for="option in selectOptions"
                  :key="option.id">
                  {{option.name}}
                </option>
              </b-select>
            </b-field>
        </template>
        <template v-else>
          <b-field>
            <b-input type="text"
              v-focus
              v-model.trim="edit.value"
              @keyup.enter="editFieldValue"
              @keyup.esc="edit = {name: null, value: null}"></b-input>
          </b-field>
      </template>
      <div>
        <b-tooltip label="Save" type="is-dark">
          <a @click.prevent="editFieldValue" href="" title="Save">
            <b-icon icon="content-save"></b-icon>
          </a>
        </b-tooltip>
        <b-tooltip label="Cancel" type="is-dark">
          <a @click.prevent="edit = {name: null, value: null}" href="" title="Cancel">
            <b-icon icon="cancel"></b-icon>
          </a>
        </b-tooltip>
      </div>
    </template>
  </div>
</template>

<script>
import KycDetailsFieldTag from '@/components/KycDetailsFieldTag'

export default {
  name: 'KycDetailsField',
  components: {
    KycDetailsFieldTag
  },
  data () {
    return {
      edit: {
        name: null,
        value: null
      }
    }
  },
  props: [
    'name',
    'displayName',
    'value',
    'selectOptions',
    'clientId',
    'editAllowed',
    'hideLabel'
  ],
  methods: {
    editFieldValue () {
      this.$emit('value-changed', this.edit)
    },
    onEditClicked (edit) {
      this.edit = edit
    }
  }
}
</script>

<style scoped>

.row {
  margin-bottom: 0.75rem;
}

.row__label {
  font-weight: bold;
  margin-right: 0.5em;
}

.row-label--edit {
  margin-bottom: 0.75rem;
}

.row__value {
  word-break: break-word;
  /* width: 80%; */
}

</style>
